/** Product name used across the page and in pixel events. */
export const PRODUCT_NAME = 'Arsenał Nauczyciela Jazzu'
